module.exports = __webpack_public_path__ + "img/fm.59c5190c.svg";